import React, { useMemo } from 'react';

import { useTabPages, TabPage } from '@ts-core/core/hooks/ui';

import ActivityAnswersPage from '../ActivityAnswersPage';
import ActivityStatementPage from '../ActivityStatementPage';

export default function useActivityDetailsPageTabs() {
  const pages: TabPage[] = useMemo((): TabPage[] => {
    return [
      {
        page: <ActivityAnswersPage />,
        tab: {
          label: 'Respuestas',
          slug: 'answers',
        },
      },
      {
        page: <ActivityStatementPage />,
        tab: {
          label: 'Consigna',
          slug: 'statement',
        },
      },
    ];
  }, []);

  return useTabPages({ pages, slugParam: 'tab' });
}
